import script from "./UploadFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadFile.vue?vue&type=script&lang=ts&setup=true"

import "./UploadFile.vue?vue&type=style&index=0&id=f497e5ba&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f497e5ba"]])

export default __exports__